export type DiceBidValue = { quantity: number; face: number };

export function diceBidDefaults(bid: DiceBidValue | null, totalDice: number) {
  const minQuantity = !bid ? 1 : bid.face < 6 ? bid.quantity : bid.quantity + 1;
  const defaultQuantity = !bid ? 1 : bid.quantity < totalDice ? bid.quantity + 1 : bid.quantity;
  const defaultFace = !bid ? 1 : bid.quantity < totalDice ? bid.face : Math.min(6, bid.face + 1);
  return { minQuantity, defaultQuantity, defaultFace };
}
